import React, { useEffect, useRef, useState } from 'react';
import selectionLibrary from '../libraries/SelectionLibrary';
import layerLibrary from '../canvas/LayerLibrary';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ProjectManager from '../canvas/ProjectManager';
import layoutEngine from '../libraries/layoutEngine';
import { hexToRgba } from '../libraries/RectangleLibrary';
import { Tooltip } from '@mui/material';

const PropertyPanel = () => {
  const [selected, setSelected] = useState([]);
  const [selectedType, setSelectedType] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const scrollRef = useRef(null);
  const unit = 1e-06
  const precesion= 1e-10
  const dbu = unit/precesion
 
  // jsonData?.units?.user_size;


 const new_unit =window.newunit?.units?.user_size
 const new_precesion = window.newunit?.units?.db_size
  // const dbu= new_unit/ new_precesion

  
  
  // console.log("newunit", new_unit, new_precesion)
  useEffect(() => {
    selectionLibrary.onChange((sel) => {
      // console.log('Selection changed:', sel);
      setSelected(sel);
      setCurrentIndex(0);
      if (sel.length > 0) {
        setSelectedType(sel[0].type);
      }
    });

    const currentSelection = selectionLibrary.getSelection();
    setSelected(currentSelection);
    if (currentSelection.length > 0) {
      setSelectedType(currentSelection[0].type);
    }
  }, []);

  useEffect(() => {
    const activeButton = scrollRef.current?.querySelector('.active-tab');
    if (activeButton && scrollRef.current) {
      const offsetLeft = activeButton.offsetLeft;
      const scrollWidth = scrollRef.current.offsetWidth;
      scrollRef.current.scrollTo({
        left: offsetLeft - scrollWidth / 2 + activeButton.offsetWidth / 2,
        behavior: 'smooth',
      });
    }
  }, [selectedType]);

  const getGroupedByType = () => {
    return selected.reduce((acc, obj) => {
      if (!acc[obj.type]) acc[obj.type] = [];
      acc[obj.type].push(obj);
      return acc;
    }, {});
  };

  if (!selected || selected.length === 0) {
    return <div style={{ color: '#888' }}>No object selected</div>;
  }

  const grouped = getGroupedByType();
  const typeOptions = Object.keys(grouped);
  const objectsOfSelectedType = grouped[selectedType] || [];

  const currentObj = objectsOfSelectedType[currentIndex];
  const indexInSelected = selected.findIndex((s) => s.id === currentObj.id);
  const allLayers = layerLibrary.getAllLayers();
  const layerOptions = Object.values(allLayers);
//   let currentLayer = layerOptions.find((l) => l.id === currentObj.ref?.layerId);
//     if (!currentLayer && currentObj.ref?.layerId) {
//   const [layerNum, dataTypeNum] = currentObj.ref.layerId.split(":").map(Number);
//   currentLayer = layerLibrary.getLayerByNumber(layerNum, dataTypeNum);
// }
    
  // ✅ Unified layer resolution for both uploaded and created elements
let currentLayer = null;

if (currentObj.ref?.layer !== undefined) {
  const layerKey = `${currentObj.ref.layer}:${currentObj.ref.datatype ?? 0}`;
  currentLayer = layerLibrary.getLayerById(layerKey);
}

// 🔑 Fallback for labels (or any object with layerId string)
if (!currentLayer && currentObj.ref?.layerId) {
  currentLayer = layerLibrary.getLayerById(currentObj.ref.layerId);
}




  // const handleChange = (index, property, value) => {
  //   if (window.canvasEngine) {
  //     window.canvasEngine.updateSelectedPropertyById(currentObj.id, currentObj.type, property, value);
  //     // const updated = [...selected];
  //     // updated[index] = { ...currentObj, [property]: value };

  //     // shiv code
  //     const updated = [...selected];
  //     updated[index] = {...currentObj,ref: {...currentObj.ref,[property]: value}};
  //     // end shiv code

  //     setSelected(updated);
  //   }
  // };
  const handleChange = (index, property, value) => {
  if (window.canvasEngine) {
    window.canvasEngine.recordState();
    window.canvasEngine.updateSelectedPropertyById(currentObj.id, currentObj.type, property, value);

    // update local state
    const updated = [...selected];
    updated[index] = {
      ...currentObj,
      ref: { ...currentObj.ref, [property]: value }
    };
    setSelected(updated);

    // 🔑 Also update layoutEngine for rectangles (like performResize does)
    if (currentObj.type === "rectangle") {
      const cellName = ProjectManager.getSelectedCell();
      layoutEngine.editElement(cellName, currentObj.id, {
        x: updated[index].ref.x,
        y: updated[index].ref.y,
        width: updated[index].ref.width,
        height: updated[index].ref.height,
      });
    }
  }
};


const handleLayerSelect = (layer) => {
  if (!layer) return;

  const { layer_number, datatype_number, color } = layer;

  if (window.canvasEngine?.updateSelectedLayer) {
    window.canvasEngine.updateSelectedLayer(`${layer_number}:${datatype_number}`);
  }

  // 🔧 Update selected objects
  const updatedSelected = selected.map(obj => {
    const ref = { ...obj.ref };

    if (obj.type === 'rectangle') {
      ref.layer = layer_number;
      ref.datatype = datatype_number;
      ref.fill = hexToRgba(color, 0.4); // Optional: update visual
    } else if (obj.type === 'label') {
      ref.layer = layer_number;
      ref.datatype = datatype_number;
      ref.color = color;
    } else if (obj.type === 'polygon') {
      ref.layer = layer_number;
      ref.datatype = datatype_number;
      ref.fill = hexToRgba(color, 0.4);   // ✅ polygons should also update fill
      ref.stroke = color;                 // optional: update stroke with layer color
    }


    return {
      ...obj,
      ref,
    };
  });

  // ✅ Reflect changes in selection
  selectionLibrary.setSelection(updatedSelected);
  setSelected(updatedSelected);
  setIsDropdownOpen(false);
};






  return (
    <div style={{ padding: '6px', color: '#ddd', fontSize: '14px' }}>
      <div style={scrollContainerStyle} ref={scrollRef}>
        {typeOptions.map((type) => (
          <button
            key={type}
            onClick={() => {
              setSelectedType(type);
              setCurrentIndex(0);
            }}
            className={selectedType === type ? 'active-tab' : ''}
            style={{
              ...buttonStyle,
              ...(selectedType === type ? activeButtonStyle : {}),
            }}
          >
            {type}
          </button>
        ))}
      </div>

      <h3 style={{ ...headerStyle, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span>
              {selectedType ? selectedType.charAt(0).toUpperCase() + selectedType.slice(1) : ''} ({currentIndex + 1}/{objectsOfSelectedType.length})
        </span>
        <div style={{ display: 'flex', gap: '2px' }}>
    <button
      disabled={currentIndex === 0}
      onClick={() => setCurrentIndex(currentIndex - 1)}
      style={{
        // backgroundColor: 'black',
        color: 'black',
        height:'25px',
        width:'25px',
        border: '1px solid #555',
        borderRadius: '4px',
        padding: '0px',
        cursor: currentIndex === 0 ? 'hidden' : 'pointer',
      }}
    >
      <Tooltip title="Previous">
      <ChevronLeftIcon />
      </Tooltip>
    </button>
    <button
      disabled={currentIndex === objectsOfSelectedType.length - 1}
      onClick={() => setCurrentIndex(currentIndex + 1)}
      style={{
        // backgroundColor: '#333',
        color: 'black',
        border: '1px solid #555',
        height:'25px',
        width:'25px',
        borderRadius: '4px',
        padding: '0px',
        cursor: currentIndex === objectsOfSelectedType.length - 1 ? 'hidden' : 'pointer',
      }}
    >
      <Tooltip title="Next">
      <ChevronRightIcon />
      </Tooltip>
    </button>
        </div>
      </h3>

      {/* Toggle Switch */}
    <div style={row}>
      <label>Common property for all:</label>
        <label style={{ position: 'relative', display: 'inline-block', width: '50px', height: '24px' }}>
      <input
      type="checkbox"
      checked={currentObj.ref?.isEnabled}
      onChange={() => handleChange(indexInSelected, 'isEnabled', !currentObj.ref?.isEnabled)}
      style={{
        opacity: 0,
        width: 0,
        height: 0,
      }}
      />
      <span
      style={{
        position: 'absolute',
        cursor: 'pointer',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: currentObj.ref?.isEnabled ? '#4CAF50' : '#ccc', // Green for ON, Gray for OFF
        borderRadius: '24px',
        transition: '0.4s',
      }}
      ></span>
      <span
      style={{
        position: 'absolute',
        content: '""',
        height: '18px',
        width: '18px',
        left: currentObj.ref?.isEnabled ? '26px' : '4px', // Move the toggle
        bottom: '3px',
        backgroundColor: '#fff',
        borderRadius: '50%',
        transition: '0.4s',
      }}
      ></span>
    </label>
    </div>

      

      {/* custom code for  */}
      {selectedType === 'rectangle' && (
        <>
        {/* Custom Dropdown */}
      <div style={row}>
        <label style={{ width: '80px' }}>Layer:</label>
        <div style={{
      position: 'relative', // Keep it relative for dropdown positioning
      flex: 1,
      height: '25px', // Match the height of other input fields
      width: '150px', // Ensure consistent width
      padding: '5px',
      border: '1px solid #555',
      borderRadius: '4px',
      backgroundColor: '#333',
      color: '#ddd',
    }}>
          <div
            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              height: '100%', // Ensure it matches the height of the container
              cursor: 'pointer',
              // width: '150%',
              padding: '0 8px', // Add padding for better alignment
            }}
          >
            <div
              style={{
                width: '12px',
                height: '12px',
                backgroundColor: currentLayer?.color || '#000',
                marginRight: '8px',
                border: '1px solid #555',
              }}
            />
            <span title={currentLayer?.id || currentObj.layerId || 'Unknown'}>
              {currentLayer
              ? `${currentLayer.layer_name} (L${currentLayer.layer_number}/DT${currentLayer.datatype_number})`
              : `Unknown Layer (${currentObj.layerId})`}
            </span>
          </div>
          {isDropdownOpen && (
            <div
              style={{
                position: 'absolute',
                top: '100%',
                left: '0px',
                right: 0,
                width: '120%',
                backgroundColor: '#222',
                border: '1px solid #555',
                zIndex: 10,
                maxHeight: '300px',
                overflowY: 'auto',
              }}
            >
              {layerOptions.map((layer) => (
                <div
                  key={layer.id}
                  onClick={() => handleLayerSelect(layer)}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '6px 10px',
                    width: '130%',
                    cursor: 'pointer',
                    backgroundColor: currentLayer?.id === layer.id ? '#444' : 'transparent',
                    color: '#ddd',
                  }}
                >
                  <div
                    style={{
                      width: '12px',
                      height: '12px',
                      backgroundColor: layer.color,
                      marginRight: '8px',
                      border: '1px solid #555',
                    }}
                  />
                  {layer.layer_name} ({layer.layer_number}/{layer.datatype_number})
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

     <div style={row}>
  <label>X:</label>
  <input
    type="number"
    style={inputb}
    value={currentObj.isUploaded ? (currentObj.ref?.x/dbu) : (currentObj.ref?.x / dbu)}   // display scaled
    onChange={(e) => {
      const inputX = parseFloat(e.target.value) * dbu; // scale back to real units
      const inputX1 = parseFloat(e.target.value) *dbu;
      if (currentObj.isUploaded) {
        // Uploaded: flip back
        handleChange(indexInSelected, "x", inputX1 );
      } else {
        // Created: convert from bottom-left → top-left
        handleChange(indexInSelected, "x", inputX );
      }
    }}
  />
</div>

      {/* <div style={row}>
        <label>Y:</label>
        <input type="number" style={inputb} value={currentObj.ref?.y*(-1) - currentObj.ref?.height} onChange={(e) => handleChange(indexInSelected, 'y', (-1)*parseFloat(e.target.value))} />
      </div> */}
      <div style={row}>
  <label>Y:</label>
  <input
    type="number"
    style={inputb}
    value={
      currentObj.isUploaded
        ? (currentObj.ref?.y * -1) /  dbu             // Uploaded: flip + scale
        : (-currentObj.ref?.y - currentObj.ref?.height) / dbu // Created: bottom-left + scale
    }
    onChange={(e) => {
      const inputY = parseFloat(e.target.value)* dbu; // scale back to real units
      const inputY1 = parseFloat(e.target.value) * dbu;
      if (currentObj.isUploaded) {
        // Uploaded: flip back
        handleChange(indexInSelected, "y", inputY1 * -1);
      } else {
        // Created: convert from bottom-left → top-left
        handleChange(indexInSelected, "y", -(inputY + currentObj.ref?.height));
      }
    }}
  />
</div>


        <div style={row}>
          <label>Width:</label>
          <input type="number" style={inputb} value={(currentObj.isUploaded ?  (currentObj.ref?.width)/ dbu             // Uploaded: flip + scale
        : (currentObj.ref?.width ) / dbu ) } onChange={(e) => {const width = parseFloat(e.target.value)*dbu;  const width1 = parseFloat(e.target.value)* dbu; 
          if (currentObj.isUploaded) {
        // Uploaded: flip back
        handleChange(indexInSelected, "width", width1 );
      } else {
        // Created: convert from bottom-left → top-left
        handleChange(indexInSelected, "width", width);
      }}} />
        </div>

        {/* <div style={row}>
          <label>Height:</label>
          <input type="number" style={inputb} value={currentObj.ref?.height} onChange={(e) => handleChange(indexInSelected, 'height', parseFloat(e.target.value))} />
        </div> */}
       <div style={row}>
          <label>Height:</label>
          <input type="number" style={inputb} value={(currentObj.isUploaded ? Math.abs( currentObj.ref?.height/  dbu )            // Uploaded: flip + scale
        :Math.abs(currentObj.ref?.height/dbu) ) } onChange={(e) => {const height = parseFloat(e.target.value)*dbu;  const height1 = parseFloat(e.target.value)* dbu; 
          if (currentObj.isUploaded) {
        // Uploaded: flip back
        handleChange(indexInSelected, "height", height1 );
      } else {
        // Created: convert from bottom-left → top-left
        handleChange(indexInSelected, "height", height);
      }}} />
        </div>


        <div style={row}>
            <label>Rotation:</label>
            <select
                style={{ background: 'transparent', color: 'white', width: '148px', height: '25px', borderRadius: '4px' }}
                value={currentObj.ref?.rotation || 0}
                onChange={(e) => handleChange(indexInSelected, 'rotation', parseInt(e.target.value))}
            >
            <option style={{ background: 'black' }} value={0}>R0</option>
            <option style={{ background: 'black' }} value={90}>R90</option>
            <option style={{ background: 'black' }} value={180}>R180</option>
            <option style={{ background: 'black' }} value={270}>R270</option>
            </select>
        </div>
        </>
      )}
      {selectedType === 'label' && (
        <>

        <div style={row}>
        <label style={{ width: '80px' }}>Layer:</label>
        <div style={{
      position: 'relative', // Keep it relative for dropdown positioning
      flex: 1,
      height: '25px', // Match the height of other input fields
      width: '150px', // Ensure consistent width
      padding: '5px',
      border: '1px solid #555',
      borderRadius: '4px',
      backgroundColor: '#333',
      color: '#ddd',
    }}>
          <div
            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              height: '100%', // Ensure it matches the height of the container
              cursor: 'pointer',
              // width: '150%',
              padding: '0 8px', // Add padding for better alignment
            }}
          >
            <div
              style={{
                width: '12px',
                height: '12px',
                backgroundColor: currentLayer?.color || '#000',
                marginRight: '8px',
                border: '1px solid #555',
              }}
            />
            <span title={currentLayer?.id || currentObj.layerId || 'Unknown'}>
              {currentLayer
              ? `${currentLayer.layer_name} (L${currentLayer.layer_number}/DT${currentLayer.datatype_number})`
              : `Unknown Layer (${currentObj.layerId})`}
            </span>
          </div>
          {isDropdownOpen && (
            <div
              style={{
                position: 'absolute',
                top: '100%',
                left: '0px',
                right: 0,
                width: '120%',
                backgroundColor: '#222',
                border: '1px solid #555',
                zIndex: 10,
                maxHeight: '300px',
                overflowY: 'auto',
              }}
            >
              {layerOptions.map((layer) => (
                <div
                  key={layer.id}
                  onClick={() => handleLayerSelect(layer)}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '6px 10px',
                    width: '130%',
                    cursor: 'pointer',
                    backgroundColor: currentLayer?.id === layer.id ? '#444' : 'transparent',
                    color: '#ddd',
                  }}
                >
                  <div
                    style={{
                      width: '12px',
                      height: '12px',
                      backgroundColor: layer.color,
                      marginRight: '8px',
                      border: '1px solid #555',
                    }}
                  />
                  {layer.layer_name} ({layer.layer_number}/{layer.datatype_number})
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

          {/* <div style={row}>
        <label>X:</label>
        <input type="number" style={inputb} value={currentObj.ref?.x} onChange={(e) => handleChange(indexInSelected, 'x', parseFloat(e.target.value))} />
      </div> */}
      <div style={row}>
        <label>X:</label>
        <input
            type="number"
            style={inputb}
            value={
            currentObj.isUploaded
            ? currentObj.ref?.x / dbu
            : currentObj.ref?.x / dbu
            }
            onChange={(e) => {
            const newVal = parseFloat(e.target.value) * dbu;
            handleChange(indexInSelected, "x", newVal);
          }}
        />
      </div>


      {/* <div style={row}>
        <label>Y:</label>
        <input type="number" style={inputb} value={currentObj.ref?.y*(-1)} onChange={(e) => handleChange(indexInSelected, 'y', (-1)*parseFloat(e.target.value))} />
      </div> */}

      <div style={row}>
          <label>Y:</label>
            <input
              type="number"
              style={inputb}
            value={
              currentObj.isUploaded
                ? currentObj.ref?.y * -1 / dbu
                : (-currentObj.ref?.y - (currentObj.ref?.fontSize || 12)) / dbu
            }
            onChange={(e) => {
              const inputY = parseFloat(e.target.value) * dbu;
              if (currentObj.isUploaded) {
                handleChange(indexInSelected, "y", inputY * -1);
              } else {
                const h = currentObj.ref?.fontSize || 12;
                handleChange(indexInSelected, "y", -(inputY + h));
              }
            }}
          />
        </div>



        <div style={row}>
            <label>Font Size:</label>
            <input
              style={inputb}
              type="number"
              value={currentObj.ref?.fontSize || ''}
              onChange={(e) => handleChange(indexInSelected, 'fontSize', parseFloat(e.target.value))}
            />
        </div>
          <div style={row}>
            <label>Text:</label>
            <input
            style={inputb}
              type="text"
              value={currentObj.ref?.text || ''}
              onChange={(e) => handleChange(indexInSelected, 'text', e.target.value)}
            />
          </div>
          <div style={row}>
            <label>FontType:</label>
            <select
              style={{background:'transparent',color:'white', width:'148px',height:'25px',borderRadius:'4px'}}
              value={currentObj.ref?.fontType || 'monospace'}
                onChange={(e) => handleChange(indexInSelected, 'fontType', e.target.value)}
            >
              <option style={{background:'black'}} value="monospace">Monospace</option>
              <option style={{background:'black'}} value="Arial">Arial</option>
              <option style={{background:'black'}} value="Verdana">Verdana</option>
              <option style={{background:'black'}} value="Times New Roman">Times New Roman</option>
              <option style={{background:'black'}} value="Courier New">Courier New</option>
            </select>
          </div>
          <div style={row}>
            <label>Rotation:</label>
            <input
              style={inputb}
              type="number"
              value={currentObj.ref?.rotation || ''}
              onChange={(e) => handleChange(indexInSelected, 'rotation', parseFloat(e.target.value))}
            />
          </div>
          <div style={row}>
            <label>Justification:</label>
            <select
              style={{background:'transparent',color:'white', width:'148px',height:'25px',borderRadius:'4px'}}
              value={currentObj.ref?.justification || 'left'}
                onChange={(e) => handleChange(indexInSelected, 'justification', e.target.value)}
            >
              <option style={{background:'black'}} value="centerleft">Center Left</option>
              <option style={{background:'black'}} value="centerright">Center Right</option>
              <option style={{background:'black'}} value="center">Center</option>
              <option style={{background:'black'}} value="upperleft">upper Left</option>
              <option style={{background:'black'}} value="upperright">upper Right</option>
              <option style={{background:'black'}} value="lowerleft">lower Left</option>
              <option style={{background:'black'}} value="lowerright">lower Right</option>
            </select>
          </div>
          <div style={row}>
              <label>Fill:</label>
              <input type="color" value={currentObj.ref?.fill || currentObj.color || '#000000'} onChange={(e) => handleChange(indexInSelected, 'fill', e.target.value)} />
          </div>

          <div style={row}>
              <label>Stroke:</label>
              <input type="color" value={currentObj.ref?.stroke || '#000000'} onChange={(e) => handleChange(indexInSelected, 'stroke', e.target.value)} />
          </div>
        </>
      )}
      {selectedType === 'polygon' && (
  <>
    {/* Layer dropdown */}
    <div style={row}>
      <label style={{ width: '80px' }}>Layer:</label>
      <div
        style={{
          position: 'relative',
          flex: 1,
          height: '25px',
          width: '150px',
          padding: '5px',
          border: '1px solid #555',
          borderRadius: '4px',
          backgroundColor: '#333',
          color: '#ddd',
        }}
      >
        <div
          onClick={() => setIsDropdownOpen(!isDropdownOpen)}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            height: '100%',
            cursor: 'pointer',
            padding: '0 8px',
          }}
        >
          <div
            style={{
              width: '12px',
              height: '12px',
              backgroundColor: currentLayer?.color || '#000',
              marginRight: '8px',
              border: '1px solid #555',
            }}
          />
          <span title={currentLayer?.id || currentObj.layerId || 'Unknown'}>
            {currentLayer
              ? `${currentLayer.layer_name} (L${currentLayer.layer_number}/DT${currentLayer.datatype_number})`
              : `Unknown Layer (${currentObj.layerId})`}
          </span>
        </div>
        {isDropdownOpen && (
          <div
            style={{
              position: 'absolute',
              top: '100%',
              left: '0px',
              right: 0,
              width: '120%',
              backgroundColor: '#222',
              border: '1px solid #555',
              zIndex: 10,
              maxHeight: '300px',
              overflowY: 'auto',
            }}
          >
            {layerOptions.map((layer) => (
              <div
                key={layer.id}
                onClick={() => handleLayerSelect(layer)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '6px 10px',
                  width: '130%',
                  cursor: 'pointer',
                  backgroundColor:
                    currentLayer?.id === layer.id ? '#444' : 'transparent',
                  color: '#ddd',
                }}
              >
                <div
                  style={{
                    width: '12px',
                    height: '12px',
                    backgroundColor: layer.color,
                    marginRight: '8px',
                    border: '1px solid #555',
                  }}
                />
                {layer.layer_name} ({layer.layer_number}/{layer.datatype_number})
              </div>
            ))}
          </div>
        )}
      </div>
    </div>

    
{/* <div style={row}>
  <label>Points:</label>
  <textarea
    style={{
      ...inputb,
      height: '80px',
      fontFamily: 'monospace',
    }}
    value={(currentObj.ref?.points || currentObj.ref?.coordinates || [])
      .map((p) => `${p[0] ?? p.x}, ${p[1] ?? p.y}`)
      .join('\n')}
    onChange={(e) => {
      const newPoints = e.target.value
        .split('\n')
        .map((line) => {
          const [x, y] = line.split(',').map((n) => parseFloat(n.trim()));
          if (!isNaN(x) && !isNaN(y)) return [x, y];   // ✅ store as array
          return null;
        })
        .filter(Boolean);

      handleChange(indexInSelected, 'points', newPoints);
    }}
  />
</div> */}
<div style={row}>
  <label>Points:</label>
  <textarea
    style={{
      ...inputb,
      height: '80px',
      fontFamily: 'monospace',
    }}
    // Display: divide by dbu and flip Y
    value={(currentObj.ref?.points || currentObj.ref?.coordinates || [])
      .map((p) => {
        const x = (p[0] ?? p.x) / dbu;
        const y = -(p[1] ?? p.y) / dbu;
        return `${x}, ${y}`;
      })
      .join('\n')}
    onChange={(e) => {
      const newPoints = e.target.value
        .split('\n')
        .map((line) => {
          const [x, y] = line.split(',').map((n) => parseFloat(n.trim()));
          if (!isNaN(x) && !isNaN(y)) {
            return [x * dbu, -y * dbu]; // multiply by dbu and flip Y back
          }
          return null;
        })
        .filter(Boolean);

      handleChange(indexInSelected, 'points', newPoints);
    }}
  />
</div>





    

    

  </>
)}

      {selectedType === 'instance' && (
        <>
          <div style={row}>
      <label>X:</label>
      <input
        type="number"
        style={inputb}
        value={(currentObj.ref?.x) / dbu}  // scaled for display
        onChange={(e) => {
          const inputX = parseFloat(e.target.value) * dbu; // scale back to real units
          handleChange(indexInSelected, 'x', inputX);
        }}
      />
    </div>

    <div style={row}>
      <label>Y:</label>
      <input
        type="number"
        style={inputb}
        value={(currentObj.ref?.y*(-1)) / dbu}  // flip + scale for display
        onChange={(e) => {
          const inputY = parseFloat(e.target.value) * dbu; // scale back
          handleChange(indexInSelected, 'y', -inputY);     // flip back
        }}
      />
    </div>


    <div style={row}>
      <label>Rotation:</label>
      <select
        style={{
          background: 'transparent',
          color: 'white',
          width: '148px',
          height: '25px',
          borderRadius: '4px',
        }}
        value={currentObj.ref?.rotation || 0}
        onChange={(e) =>
          handleChange(indexInSelected, 'rotation', parseInt(e.target.value))
        }
      >
        <option style={{ background: 'black' }} value={0}>
          R0
        </option>
        <option style={{ background: 'black' }} value={90}>
          R90
        </option>
        <option style={{ background: 'black' }} value={180}>
          R180
        </option>
        <option style={{ background: 'black' }} value={270}>
          R270
        </option>
      </select>
    </div>


        </>
      )}
    </div>
  );
};

// Styling
const row = {
  marginBottom: '8px',
  fontSize: '14px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
};

const inputb = {
  height: '25px',
  width: '146px',
  padding: '5px',
  border: '1px solid #555',
  borderRadius: '4px',
  backgroundColor: '#333',
  color: '#ddd',
};

const iconStyle = {
  color: '#aaa',
  fontSize: '20px',
  cursor: 'pointer', // Add pointer cursor for interactivity
};
const scrollContainerStyle = {
  display: 'flex',
  overflowX: 'auto',
  gap: '0px',
  paddingBottom: '0px',
  marginBottom: '15px',
  whiteSpace: 'nowrap',
  scrollbarWidth: 'none',
  msOverflowStyle: 'none',
};

const buttonStyle = {
  padding: '6px 10px',
  backgroundColor: '#333',
  color: '#ddd',
  border: '1px solid #555',
  borderRadius: '0px',
  whiteSpace: 'nowrap',
  cursor: 'pointer',
  flexShrink: 0,
};

const activeButtonStyle = {
  backgroundColor: '#555',
  color: '#fff',
  border: '1px solid #aaa',
};

const headerStyle = {
  fontSize: '16px',
  marginBottom: '10px',
  borderBottom: '1px solid #444',
  paddingBottom: '5px',
};

export default PropertyPanel;